module.exports = __webpack_public_path__ + "static/media/ic_close_black.2aa9e758.svg";